export default __webpack_public_path__ + "static/media/set_8_Image-7.a0d1c2fb.svg";